// material-ui
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project import
import { drawerWidth } from '../../../config';

const miniDrawerWidth = 64;

const baseDrawerMixin = (theme) => ({
  zIndex: theme.zIndex.drawer + 10,
  borderRight: '1px solid',
  borderRightColor: theme.palette.divider,
  backgroundColor: '#fff',
  overflowX: 'hidden',
  overflowY: 'auto',
  boxShadow: 'none'
});

const openedMixin = (theme) => ({
  ...baseDrawerMixin(theme),
  width: drawerWidth,
  minWidth: drawerWidth,
  maxWidth: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  })
});

const closedMixin = (theme) => ({
  ...baseDrawerMixin(theme),
  width: miniDrawerWidth,
  minWidth: miniDrawerWidth,
  maxWidth: miniDrawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  })
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  width: open ? drawerWidth : miniDrawerWidth,
  zIndex: theme.zIndex.drawer + 10,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme)
  })
}));

export default MiniDrawerStyled;
